import React, { useEffect, useMemo, useState } from "react";
import Header from "../../../component/organisms/header";
import MainLayout from "../../../component/atoms/layout/mainLayout";
import Sidebar from "../../../component/organisms/sidebar";
import DetailPageLayout from "../../../component/atoms/layout/detail/detailPageLayout";
import TableTitle from "./../../../component/atoms/text/table/tableTitle";
import TableTop from "./../../../component/atoms/layout/table/tableTop";
import TableCount from "./../../../component/molecules/tableCount";
import SearchBar from "./../../../component/atoms/input/searchBar";
import ExcelBtn from "./../../../component/atoms/button/excelBtn";
import EventBtn from "../../../component/atoms/button/eventBtn";
// import Pagination from "./../../../component/molecules/pagination";
import { route } from "./../../../router/route";
import Table from "../../../component/atoms/layout/table/table";
import Tr from "./../../../component/atoms/layout/table/tr";
import Th from "./../../../component/atoms/layout/table/th";
import Checkbox from "./../../../component/atoms/input/checkbox";
import TableText from "./../../../component/atoms/text/table/tableText";
import Td from "./../../../component/atoms/layout/table/td";
import { errorHandler } from "../../../util/errorHandler";
import TableFilter from "./../../../component/atoms/layout/table/tableFilter";
import RedBtn from "../../../component/atoms/button/redBtn";
import GrayBtn from "../../../component/atoms/button/grayBtn";
import Modal from "../../../component/templates/Modal";
import { toast } from "react-toastify";
import { toastMsg } from "../../../util/toastMsg";
import PopupOverLay from "../../../component/templates/PopupOverlay";
import Popup from "../../../component/molecules/popup";
import PretendardText from "../../../component/atoms/text/pretendardText";
import SubSideBar from "../../../component/organisms/subSideBar";
import SubSideBarItem from "../../../component/molecules/subSideBarItem";
import MainInput from "./../../../component/atoms/input/mainInput";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import scrollToTop from "../../../util/scrollToTop";
import DividedBtn from "../../../component/atoms/button/dividedBtn";
import BasicBtn from "./../../../component/atoms/button/basicBtn";
import { useRecoilState } from "recoil";
import {
  productIsUploadState,
  productManagementState,
} from "../../../store/productState";
import ProductApi from "../../../api/product.api";
import moment from "moment";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import ChapterApi from "../../../api/chapter.api";

// TODO:
// - 추후 미리보기 페이지 구현 필요 (프리뷰 페이지 별도로 만들어야 할듯)

const ShoppingProductCreateChapter = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams, setSearchParams] = useSearchParams(); // eslint-disable-line no-unused-vars

  // ---------- 마운트가 되면 ---------- //
  useEffect(() => {
    // 편집 권한 체크
    const writeMenu = sessionStorage.getItem("writeMenu");

    if (!writeMenu?.includes(route.shopping_product)) {
      navigate(-1);
      toast(
        <>
          편집 권한이 없습니다.
          <br />
          최고관리자에게 문의하세요.
        </>
      );
      return;
    }

    getChapterTitleList();

    // url 직접 입력으로 들어온 경우 기본 내용 설정 페이지로 이동
    if (productManagementValue.merchMainCategoryId === 0) {
      navigate(route.shopping_product_create_basic);
    }

    // 임시저장에서 불러온 경우 상품 업로드 상태 변경
    if (!productManagementValue.id) {
      setProductIsUpload(true);
    } else {
      setProductIsUpload(false);
    }
  }, [location]); // eslint-disable-line react-hooks/exhaustive-deps

  const [keyword, setKeyword] = useState("");

  // ---------- 새로고침 이벤트 관련 ---------- //
  useEffect(() => {
    const handleBeforeUnload = (event) => {
      event.preventDefault();
      event.returnValue = "";
    };

    // 새로고침 및 페이지 떠남 이벤트 감지
    window.addEventListener("beforeunload", handleBeforeUnload);

    // 컴포넌트가 언마운트될 때 이벤트 리스너 제거
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  // ---------- 페이지 타이틀 관련 ---------- //
  const pageTitleList = [
    "01. 기본 내용 설정",
    "02. 상세 내용 설정",
    "03. 목차/커리큘럼 설정",
    "04. 썸네일 및 배너 설정",
    "05. 기타 설정",
  ];

  // ---------- 상품 업로드 상태 관련 ---------- //
  const [, setProductIsUpload] = useRecoilState(productIsUploadState);

  // ---------- 상품 추가 입력값 관련 ---------- //
  const [productManagementValue, setProductManagementValue] = useRecoilState(
    productManagementState
  );

  // ---------- 전체 영역 팝업 상태 관련 ---------- //
  const [popupOpen, setPopupOpen] = useState({
    temporary: false, // 임시저장
    chapterTitle: false,
    chapterCreate: false,
  });

  // ---------- 대제목 관련 ---------- //
  const [chapterTitleList, setChapterTitleList] = useState([]);
  const [selectedChapterTitle, setSelectedChapterTitle] = useState("");
  const [selectedPopupChapterTitle, setSelectedPopupChapterTitle] = useState({
    id: 0,
    title: "",
  });

  useEffect(() => {
    setSelectedPopupChapterTitle({
      id: 0,
      title: "",
    });
  }, [popupOpen]);

  // 대제목 리스트 가져오기
  const getChapterTitleList = async (lastChapterTitleId) => {
    try {
      const data = {
        page: 1,
        size: 0,
        sort: "orderNumber",
        merchId: productManagementValue.id,
        orderBy: "ASC",
      };

      const response = (await ChapterApi.getListChapterTitle(data)).data.data
        .content;
      setChapterTitleList(response);

      if (lastChapterTitleId) {
        // response에서 lastChapterTitleId와 같은 id가 있는 경우에만 setSelectedChapterTitle 해주기
        const findChapterTitle = response.find(
          (item) => item.id === lastChapterTitleId
        );

        if (findChapterTitle) {
          setSelectedChapterTitle(findChapterTitle.id);
        } else {
          setSelectedChapterTitle(response[0]?.id);
        }
      } else {
        setSelectedChapterTitle(response[0]?.id);
      }

      if (selectedChapterTitle) {
        getChapterList(selectedChapterTitle);
      }
    } catch (error) {
      errorHandler(error);
    }
  };

  // 대제목 추가하기
  const createChapterTitle = async () => {
    try {
      if (selectedPopupChapterTitle.title === "") {
        toast("대제목명을 입력해주세요.");
        return;
      } else {
        const data = {
          merchId: productManagementValue.id,
          title: selectedPopupChapterTitle.title,
        };
        await ChapterApi.createChapterTitle(data);
        setSelectedPopupChapterTitle({
          id: 0,
          title: "",
        });
        toast(toastMsg.create);
        getChapterTitleList();
      }
    } catch (error) {
      errorHandler(error);
    }
  };

  // 대제목 수정하기
  const updateChapterTitle = async () => {
    try {
      if (
        selectedPopupChapterTitle.id !== 0 &&
        selectedPopupChapterTitle.title === ""
      ) {
        toast("대제목명을 입력해주세요.");
        return;
      } else {
        const updatedChapterTitleList = chapterTitleList.map((title) => {
          if (title.id === selectedPopupChapterTitle.id) {
            return {
              id: selectedPopupChapterTitle.id,
              title: selectedPopupChapterTitle.title,
            };
          }

          return title;
        });

        const data = {
          chapterTitleList: updatedChapterTitleList,
        };

        await ChapterApi.updateChapterTitle(data);

        setSelectedPopupChapterTitle({
          id: 0,
          title: "",
        });
        toast(toastMsg.update);
        getChapterTitleList();
      }
    } catch (error) {
      errorHandler(error);
    }
  };

  // 대제목 삭제하기
  const [chapterTitleDeleteModalOpen, setChapterTitleDeleteModalOpen] =
    useState(false);

  const chapterTitleDeleteHandler = async () => {
    try {
      await ChapterApi.deleteChapterTitle(selectedPopupChapterTitle.id);
      toast(toastMsg.delete);
      setChapterTitleDeleteModalOpen(false);
      setSelectedPopupChapterTitle({
        id: 0,
        title: "",
      });
      getChapterTitleList();
    } catch (error) {
      errorHandler(error);
    }
  };

  // 대제목 드래그 앤 드롭
  const handleDragAndDrop = async (result) => {
    const { destination, source } = result;

    // 드래그가 취소된 경우
    if (!destination) return;

    // 기존 배열을 복사
    const updatedList = Array.from(chapterTitleList);

    // 드래그된 요소를 배열에서 제거하고 새로운 위치에 삽입
    const [reorderedItem] = updatedList.splice(source.index, 1);
    updatedList.splice(destination.index, 0, reorderedItem);

    setChapterTitleList(updatedList);

    // 상태 업데이트
    const data = {
      chapterTitleList: updatedList,
    };

    await ChapterApi.updateChapterTitle(data);

    setSelectedPopupChapterTitle({
      id: 0,
      title: "",
    });

    getChapterTitleList();
  };

  // ---------- 페이지네이션 관련 ---------- //
  // const page = useMemo(() => {
  //   return searchParams.get("page") ? searchParams.get("page") : 1;
  // }, [searchParams]);

  // const [pagination, setPagination] = useState({
  //   size: 5, // 한 페이지에 표시될 게시글 수
  //   rangeSize: 5, // 하단 페이지 사이즈
  //   totalCount: 0,
  //   totalPages: 0,
  //   first: false,
  //   last: false,
  // });

  // ---------- 목차 관련 ---------- //
  // 목차 리스트 관련 상태
  const [chapterList, setChapterList] = useState([]);

  // 목차 리스트 가져오기
  const getChapterList = async (chapterTitle) => {
    try {
      const data = {
        // page: page,
        page: 1,
        // size: pagination.size,
        size: 0,
        sort: "orderNumber",
        orderBy: "ASC",
        merchId: productManagementValue.id,
      };

      if (chapterTitle) {
        data.chapterTitleId = chapterTitle;
      }

      if (searchParams.get("keyword")) {
        data.keyword = searchParams.get("keyword");
      }

      const response = (await ChapterApi.getListChapter(data)).data.data;
      setChapterList(response.content);

      // setPagination({
      //   ...pagination,
      //   totalCount: response.totalCount,
      //   totalPages: response.totalPage || Math.ceil(response.totalCount / 5),
      //   first: response.first,
      //   last: response.last,
      // });
    } catch (error) {
      errorHandler(error);
    }
  };

  useEffect(() => {
    if (selectedChapterTitle) {
      getChapterList(selectedChapterTitle);
    } else return;
  }, [selectedChapterTitle]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    setSelectedChapterTitle(0);

    const lastChapterTitleId = sessionStorage.getItem("lastChapterTitleId");

    getChapterTitleList(Number(lastChapterTitleId));
  }, [productManagementValue.id]); // eslint-disable-line react-hooks/exhaustive-deps

  const [deleteId, setDeleteId] = useState(0);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);

  const deleteHandler = async () => {
    try {
      await ChapterApi.deleteChapter(deleteId);
      toast(toastMsg.delete);
      setDeleteModalOpen(false);
      getChapterList();
    } catch (error) {
      errorHandler(error);
    }
  };

  // 체크 관련
  const isChapterAllCheck = useMemo(() => {
    const checkedList = chapterList.filter((item) => item.checked);
    return (
      checkedList.length !== 0 && checkedList.length === chapterList.length
    );
  }, [chapterList]);

  // 목차/커리큘럼 상단 버튼 그룹 관련
  const [chapterButtonGroupOpen, setChapterButtonGroupOpen] = useState(false);

  useEffect(() => {
    const checkedList = chapterList.filter((item) => item.checked);
    if (checkedList.length > 0) {
      setChapterButtonGroupOpen(true);
    } else {
      setChapterButtonGroupOpen(false);
    }
  }, [chapterList]);

  // ---------- 순서 변경 ---------- //
  const orderEdit = async (chapterId, order, keyword) => {
    try {
      const data = {
        orderDirection: order,
        chapterSearchDto: {
          merchId: Number(productManagementValue.id),
        },
      };

      if (selectedChapterTitle) {
        data.chapterSearchDto.chapterTitleId = selectedChapterTitle;
      }

      if (keyword) {
        data.chapterSearchDto.keyword = keyword;
      }

      await ChapterApi.updateOrderChapter(chapterId, data);

      getChapterList(selectedChapterTitle);
    } catch (error) {
      errorHandler(error);
    }
  };

  // 목차/커리큘럼 활성 상태 관련
  const [chapterFilterOpen, setChapterFilterOpen] = useState(-1);
  const [chapterStatusId, setChapterStatusId] = useState(null);
  const [chapterStatus, setChapterStatus] = useState(null);
  const [chapterStatusModalTitle, setChapterStatusModalTitle] = useState("");
  const [chapterStatusModalOpen, setChapterStatusModalOpen] = useState(false);

  const activationFunc = async () => {
    try {
      const data = {
        activation: chapterStatus,
      };
      await ChapterApi.updateActivationChapter(chapterStatusId, data);
      toast(toastMsg.create);
      setChapterFilterOpen(-1);
      setChapterStatusModalOpen(false);
      getChapterList(selectedChapterTitle);
    } catch (error) {
      errorHandler(error);
    }
  };

  // ---------- 임시저장 관련 ---------- //
  const [storageList, setStorageList] = useState([]);
  const [storageListCount, setStorageListCount] = useState(0);

  const getStorageList = async () => {
    try {
      const data = {
        page: 1,
        size: 0,
        saveStatus: "N",
      };
      const response = await ProductApi.getListProduct(data);
      setStorageList(response.data.data.content);
      setStorageListCount(response.data.data.totalCount);
    } catch (error) {
      errorHandler(error);
    }
  };

  useEffect(() => {}, [productManagementValue.id]);

  // 임시저장 데이터 삭제 관련
  const [deleteStorageItemModalOpen, setDeleteStorageItemModalOpen] =
    useState(false);
  const [deleteStorageItemId, setDeleteStorageItemId] = useState(0);

  const handleDeleteStorageItem = async () => {
    try {
      await ProductApi.deleteProduct(deleteStorageItemId);
      toast(toastMsg.delete);
      setDeleteStorageItemModalOpen(false);
      getStorageList();
    } catch (error) {
      errorHandler(error);
    }
  };

  // 데이터 불러오기
  const handleLoadStorageItem = async (id) => {
    try {
      const response = (await ProductApi.getByIdProduct(id)).data.data.content;

      setProductManagementValue({
        ...response,
        merchMainCategoryId: response?.merchMainCategory?.id || 0,
        merchSubCategoryId: response?.merchSubCategory?.id || 0,
        title: response.title || "",
        writer: response.writer || "",
        price: response.price || 0,
        isPreviewEnabled: response.isPreviewEnabled || false,
        isFreeTrial: response.isFreeTrial || false,
        isComingSoon: response.isComingSoon || false,
        isMembershipOnly: response.isMembershipOnly || false,
        intro: response.intro || "",
        content: response.content || "",
        thumbnailOriginFileName: response.thumbnailOriginFileName || "",
        thumbnailServerFileName: response.thumbnailServerFileName || "",
        bannerOriginFileName: response.bannerOriginFileName || "",
        bannerServerFileName: response.bannerServerFileName || "",
        relatedMerchUse: response.relatedMerchUse || false,
        openAlarmUse: response.openAlarmUse || false,
        merchType: response.merchType || "SHOP",
        merchContentType: response.merchContentType || "BOOK",
      });
      setProductIsUpload(false);
      setPopupOpen((prevPopup) => ({
        ...prevPopup,
        temporary: false,
      }));

      navigate(route.shopping_product_create_basic);
      toast("임시저장 데이터를 불러왔습니다.");
      scrollToTop();
    } catch (error) {
      errorHandler(error);
    }
  };

  // ---------- 다음 단계로 이동 ---------- //
  const handleNextStep = async () => {
    try {
      if (chapterTitleList.length === 0) {
        toast("대제목을 추가해주세요.");
        return;
      } else {
        const data = {
          // page: page,
          page: 1,
          // size: pagination.size,
          size: 0,
          sort: "orderNumber",
          orderBy: "ASC",
          merchId: productManagementValue.id,
        };

        const response = (await ChapterApi.getListChapter(data)).data.data
          .content;

        if (response.length === 0) {
          toast("목차를 추가해주세요.");
          return;
        } else {
          navigate(route.shopping_product_create_image);
        }
      }
    } catch (error) {
      errorHandler(error);
    }
  };

  return (
    <>
      <Header />
      <MainLayout
        style={{
          position: "relative",
          gap: 306,
        }}
      >
        <Sidebar />

        <SubSideBar title="상품 추가">
          {pageTitleList.map((item, index) => {
            return (
              <React.Fragment key={index}>
                <SubSideBarItem
                  style={{
                    cursor: "default",
                  }}
                  selected={item === pageTitleList[2]}
                >
                  {item}
                </SubSideBarItem>
              </React.Fragment>
            );
          })}
        </SubSideBar>

        <SubSideBar top="432px" title="상세 목차">
          {/* <SubSideBarItem
            selected={selectedChapterTitle === ""}
            onClick={() => {
              setSelectedChapterTitle("");
              getChapterTitleList();
            }}
          >
            전체
          </SubSideBarItem> */}
          {chapterTitleList.map((item, index) => {
            return (
              <React.Fragment key={index}>
                <SubSideBarItem
                  onClick={() => {
                    setSelectedChapterTitle(item.id);

                    sessionStorage.setItem("lastChapterTitleId", item.id);
                  }}
                  selected={selectedChapterTitle === item.id}
                >
                  {index + 1}. {item.title}
                </SubSideBarItem>
              </React.Fragment>
            );
          })}

          <SubSideBarItem
            style={{
              borderTop: "0.5px solid rgba(255, 255, 255, 0.12)",
              cursor: "default",
              marginBottom: 5,
            }}
            selected={false}
          >
            대제목 관리
            <img
              src="/assets/admin/icons/ico_setting.svg"
              style={{
                marginLeft: 5,
                width: 13,
                height: 13,
                cursor: "pointer",
              }}
              onClick={() => {
                setPopupOpen((prevPopup) => ({
                  ...prevPopup,
                  chapterTitle: true,
                }));
              }}
              alt="대제목 관리"
            />
          </SubSideBarItem>
          {/* <SubSideBarItem
            style={{
              borderTop: "0.5px solid rgba(255, 255, 255, 0.12)",
              cursor: "default",
            }}
            selected={false}
          >
            <Checkbox
              style={{
                marginRight: 8,
              }}
            />
            대제목 사용안함
          </SubSideBarItem> */}
        </SubSideBar>

        {/* 본문 영역 */}
        <DetailPageLayout>
          <TableTitle>{pageTitleList[2]}</TableTitle>

          {/* 테이블 상단 영역 */}
          <TableTop>
            {/* <TableCount text={"상품"} count={pagination.totalCount} /> */}
            <TableCount text={"상품"} count={chapterList.length || 0} />
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 10,
              }}
            >
              <SearchBar
                value={keyword}
                placeholder={"목차명"}
                onChange={(e) => {
                  setKeyword(e.target.value);
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    if (keyword !== "") {
                      navigate(
                        `${route.shopping_product_create_chapter}?page=1&keyword=${keyword}`,
                        {
                          replace: true,
                        }
                      );
                    } else {
                      navigate(route.shopping_product_create_chapter, {
                        replace: true,
                      });
                    }
                  }
                }}
                onClick={() => {
                  navigate(
                    `${route.shopping_product_create_chapter}?page=1&keyword=${keyword}`,
                    {
                      replace: true,
                    }
                  );
                }}
              />
              {/* <ExcelBtn /> */}
              <EventBtn
                text={"목차 추가하기"}
                onClick={() => {
                  if (chapterTitleList.length === 0) {
                    toast("대제목을 추가해주세요.");
                    return;
                  } else {
                    navigate(
                      `${route.shopping_product_chapter_create}/${productManagementValue.id}`
                    );
                  }
                }}
              />
            </div>
          </TableTop>
          {/* 버튼 그룹 */}
          {chapterButtonGroupOpen && (
            <div
              style={{
                width: "100%",
                height: 49,
                display: "flex",
                gap: 12,
              }}
            >
              {chapterList.filter((item) => item.checked).length === 1 && (
                <>
                  <RedBtn
                    onClick={() => {
                      setDeleteId(
                        chapterList.filter((item) => item.checked)[0].id
                      );
                      setDeleteModalOpen(true);
                    }}
                  >
                    삭제
                  </RedBtn>
                  <GrayBtn
                    onClick={() => {
                      const checkedList = chapterList.filter(
                        (item) => item.checked
                      );
                      orderEdit(checkedList[0].id, "TOP", keyword);
                    }}
                  >
                    맨 위로
                  </GrayBtn>
                  <GrayBtn
                    onClick={() => {
                      const checkedList = chapterList.filter(
                        (item) => item.checked
                      );
                      orderEdit(checkedList[0].id, "UP", keyword);
                    }}
                  >
                    위로
                  </GrayBtn>
                  <GrayBtn
                    onClick={() => {
                      const checkedList = chapterList.filter(
                        (item) => item.checked
                      );
                      orderEdit(checkedList[0].id, "DOWN", keyword);
                    }}
                  >
                    아래로
                  </GrayBtn>
                  <GrayBtn
                    onClick={() => {
                      const checkedList = chapterList.filter(
                        (item) => item.checked
                      );
                      orderEdit(checkedList[0].id, "BOTTOM", keyword);
                    }}
                  >
                    맨 아래로
                  </GrayBtn>
                </>
              )}
            </div>
          )}

          {/* 테이블 영역 */}
          <Table>
            <colgroup>
              {/* 합계: 1044px */}
              {/* 체크박스 */}
              <col width="56px" />
              {/* No */}
              <col width="51px" />
              {/* 목차명 */}
              <col width="600px" />
              {/* 상태 */}
              <col width="119px" />
              {/* 미리보기 적용 */}
              <col width="218px" />
            </colgroup>
            <thead>
              <Tr style={{ height: "41px", background: "#272829" }}>
                <Th style={{ paddingLeft: "16px" }}>
                  <Checkbox
                    checked={isChapterAllCheck}
                    onChange={(e) => {
                      if (e.target.checked) {
                        setChapterList(
                          chapterList.map((item) => {
                            return {
                              ...item,
                              checked: true,
                            };
                          })
                        );
                      } else {
                        setChapterList(
                          chapterList.map((item) => {
                            return {
                              ...item,
                              checked: false,
                            };
                          })
                        );
                      }
                    }}
                  />
                </Th>
                <Th>
                  <TableText
                    style={{
                      fontWeight: "600",
                      lineHeight: "22.75px",
                    }}
                  >
                    No
                  </TableText>
                </Th>
                <Th>
                  <TableText
                    style={{
                      fontWeight: "600",
                      lineHeight: "22.75px",
                    }}
                  >
                    목차명
                  </TableText>
                </Th>
                <Th>
                  <TableText
                    style={{
                      fontWeight: "600",
                      lineHeight: "22.75px",
                    }}
                  >
                    상태
                  </TableText>
                </Th>
                <Th
                  style={{
                    paddingRight: 142,
                  }}
                >
                  <TableText
                    style={{
                      fontWeight: "600",
                      lineHeight: "22.75px",
                    }}
                  >
                    미리보기 적용
                  </TableText>
                </Th>
              </Tr>
            </thead>
            <tbody>
              {chapterList.map((item, index) => {
                return (
                  <Tr
                    key={index}
                    style={{
                      height: "72px",
                      background: "transparent",
                      borderBottom: "1px solid rgba(255, 255, 255, 0.12)",
                    }}
                  >
                    <Td style={{ paddingLeft: "16px" }}>
                      <Checkbox
                        checked={item.checked}
                        onChange={() => {
                          item.checked = !item.checked;
                          setChapterList([...chapterList]);
                        }}
                      />
                    </Td>
                    <Td>
                      <TableText>{item.orderNumber}</TableText>
                    </Td>
                    <Td>
                      <TableText
                        style={{
                          width: 590,
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          navigate(
                            `${route.shopping_product_chapter_edit}/${item.id}`
                          );
                        }}
                      >
                        {item.title}
                      </TableText>
                    </Td>
                    <Td>
                      <TableFilter
                        style={{
                          width: "fit-content",
                          gap: 10,
                        }}
                        onClick={() => {
                          chapterFilterOpen === index
                            ? setChapterFilterOpen(-1)
                            : setChapterFilterOpen(index);
                        }}
                        isOpen={chapterFilterOpen === index}
                        selectedValue={item.activation}
                        list={[
                          {
                            value: true,
                            title: "활성",
                            onClick: () => {
                              setChapterStatusId(item.id);
                              setChapterStatus(true);
                              setChapterStatusModalTitle("활성");
                              setChapterStatusModalOpen(true);
                            },
                          },
                          {
                            value: false,
                            title: "숨김",
                            onClick: () => {
                              setChapterStatusId(item.id);
                              setChapterStatus(false);
                              setChapterStatusModalTitle("숨김");
                              setChapterStatusModalOpen(true);
                            },
                          },
                        ]}
                      />
                    </Td>
                    <Td
                      style={{
                        paddingRight: 142,
                      }}
                    >
                      <TableText
                        style={{
                          textAlign: "center",
                        }}
                      >
                        {item.isPreview ? "미리보기 적용" : "-"}
                      </TableText>
                    </Td>
                  </Tr>
                );
              })}
            </tbody>
          </Table>
          {/* 페이지네이션 영역 */}
          {/* <Pagination
            route={route.shopping_product_create_chapter}
            queryString={
              keyword ? `keyword=${searchParams.get("keyword")}` : ""
            }
            currentPage={page}
            totalPages={pagination.totalPages}
            rangeSize={pagination.rangeSize}
            first={pagination.first}
            last={pagination.last}
          /> */}
          <div
            style={{
              width: "100%",
              height: 79,
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "flex-end",
              gap: 12,
            }}
          >
            <BasicBtn
              isTransparent={true}
              onClick={() => {
                navigate(route.shopping_product_create_detail);
                scrollToTop();
              }}
            >
              이전으로
            </BasicBtn>
            {/* <BasicBtn isBlue={true} onClick={() => {}}>
              미리보기
            </BasicBtn> */}
            <DividedBtn
              onClick={() => {
                setPopupOpen((prevPopup) => ({
                  ...prevPopup,
                  temporary: true,
                }));
              }}
              text1="임시저장"
              text2={storageListCount}
              textHandler={() => {
                setPopupOpen((prevPopup) => ({
                  ...prevPopup,
                  temporary: true,
                }));
              }}
            />
            <BasicBtn onClick={handleNextStep}>다음으로</BasicBtn>
          </div>
        </DetailPageLayout>
      </MainLayout>

      {/* 대제목 관리 팝업 */}
      {popupOpen.chapterTitle && (
        <PopupOverLay
          isOpen={true}
          onClick={() => {
            setPopupOpen((prevPopup) => ({
              ...prevPopup,
              chapterTitle: false,
            }));
          }}
        >
          <Popup
            headerTitle="대제목 관리"
            footerBtnText="저장하기"
            onClick={() => {
              setPopupOpen((prevPopup) => ({
                ...prevPopup,
                chapterTitle: false,
              }));
            }}
            footerBtnHandler={() => {
              if (selectedPopupChapterTitle.id === 0) {
                createChapterTitle();
              } else {
                updateChapterTitle();
              }
            }}
          >
            <div
              style={{
                width: "fit-content",
                height: "fit-content",
                margin: "16px 30px",
                display: "flex",
              }}
            >
              <div
                style={{
                  width: "200px",
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <DragDropContext onDragEnd={handleDragAndDrop}>
                  <Droppable droppableId="chapterTitles">
                    {(provided) => (
                      <div {...provided.droppableProps} ref={provided.innerRef}>
                        {chapterTitleList.map((item, index) => (
                          <Draggable
                            key={item.id}
                            draggableId={String(item.id)}
                            index={index}
                          >
                            {(provided) => (
                              <div
                                ref={provided.innerRef}
                                {...provided.draggableProps}
                                {...provided.dragHandleProps}
                              >
                                <SubSideBarItem
                                  selected={
                                    selectedPopupChapterTitle.id === item.id
                                  }
                                  move={true}
                                  onClick={() => {
                                    setSelectedPopupChapterTitle({
                                      id: item.id,
                                      title: item.title,
                                    });
                                  }}
                                >
                                  {item.title}
                                </SubSideBarItem>
                              </div>
                            )}
                          </Draggable>
                        ))}
                        {provided.placeholder}
                      </div>
                    )}
                  </Droppable>
                </DragDropContext>

                {/* <SubSideBarItem selected={true} move={true}>
                  챗GPT 시대, 어떻게 공부 하나요?
                </SubSideBarItem>
                <SubSideBarItem selected={false} move={true}>
                  대화형 AI가 가져올 취업시장의 변화 미리보기
                </SubSideBarItem>
                <SubSideBarItem selected={false} move={true}>
                  네이버도 벌써부터 AI 인재를 찾고 있습니다
                </SubSideBarItem> */}

                <SubSideBarItem
                  icon="plus"
                  selected={selectedPopupChapterTitle.id === 0}
                  onClick={() => {
                    setSelectedPopupChapterTitle({
                      id: 0,
                      title: "",
                    });
                  }}
                  plusHandler={() => {
                    setSelectedPopupChapterTitle({
                      id: 0,
                      title: "",
                    });
                  }}
                >
                  대제목 추가하기
                </SubSideBarItem>
              </div>
              <span
                style={{
                  width: "1px",
                  height: "399px",
                  marginLeft: "14px",
                  marginRight: "20px",
                  backgroundColor: "rgba(255, 255, 255, 0.12)",
                }}
              />
              <div
                style={{
                  width: "338px",
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                }}
              >
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                    gap: "3px",
                  }}
                >
                  <PretendardText
                    style={{
                      fontSize: "15px",
                      fontWeight: "400",
                      lineHeight: "22px",
                      color: "#aaa",
                    }}
                  >
                    대제목
                  </PretendardText>
                  <MainInput
                    type={"text"}
                    placeholder={"대제목명을 입력해 주세요."}
                    style={{ width: "338px" }}
                    value={selectedPopupChapterTitle.title}
                    onChange={(e) => {
                      setSelectedPopupChapterTitle({
                        ...selectedPopupChapterTitle,
                        title: e.target.value,
                      });
                    }}
                  />
                </div>
                <div
                  style={{
                    marginTop: 303,
                    width: "100%",
                    height: 22,
                    display: "flex",
                    justifyContent: "flex-end",
                    alignItems: "center",
                  }}
                >
                  {selectedPopupChapterTitle.id !== 0 && (
                    <PretendardText
                      style={{
                        fontSize: "15px",
                        fontWeight: "500",
                        lineHeight: "21.5px",
                        color: "rgba(181, 181, 181, 0.5)",
                        marginTop: "5px",
                        cursor: "pointer",
                        textDecorationLine: "underline",
                      }}
                      onClick={() => {
                        setChapterTitleDeleteModalOpen(true);
                      }}
                    >
                      삭제하기
                    </PretendardText>
                  )}
                </div>
              </div>
            </div>
            <ul
              style={{
                position: "absolute",
                left: 30,
                bottom: 31,
                listStyle: "disc",
                listStylePosition: "inside",
                listColor: "#aaa",
                marginRight: 0,
              }}
            >
              <li
                style={{
                  fontFamily: "Pretendard",
                  fontSize: "15px",
                  fontWeight: "400",
                  lineHeight: "22px",
                  color: "var(--text3, rgba(181, 181, 181, 0.5))",
                }}
              >
                마우스 드래그로 카테고리 순서를 조정해보세요
              </li>
              <li
                style={{
                  fontFamily: "Pretendard",
                  fontSize: "15px",
                  fontWeight: "400",
                  lineHeight: "22px",
                  color: "var(--text3, rgba(181, 181, 181, 0.5))",
                }}
              >
                현재 대제목 순서대로 자동 넘버링이 설정됩니다
              </li>
            </ul>
          </Popup>
        </PopupOverLay>
      )}

      {/* 임시저장 팝업 */}
      {popupOpen.temporary && (
        <PopupOverLay
          isOpen={true}
          onClick={() => {
            setPopupOpen((prevPopup) => ({
              ...prevPopup,
              temporary: false,
            }));
          }}
        >
          <Popup
            headerTitle="임시저장 글"
            noFooter={true}
            onClick={() => {
              setPopupOpen((prevPopup) => ({
                ...prevPopup,
                temporary: false,
              }));
            }}
          >
            <div
              className="custom-scrollbar"
              style={{
                width: "100%",
                maxHeight: 284,
                overflowY: "auto",
                display: "flex",
                flexDirection: "column",
                marginTop: 16,
                padding: "0px 30px",
              }}
            >
              {storageList.map((item, index) => {
                return (
                  <div
                    key={index}
                    style={{
                      width: "100%",
                      height: 71,
                      padding: "15px 0px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      borderBottom:
                        "0.5px solid var(--outline1, rgba(255, 255, 255, 0.12))",
                    }}
                  >
                    <div
                      style={{
                        width: 515,
                        display: "flex",
                        flexDirection: "column",
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        handleLoadStorageItem(item.id);
                      }}
                    >
                      <PretendardText
                        className="truncate"
                        style={{
                          width: "100%",
                          fontWeight: 500,
                          fontSize: 14,
                          lineHeight: "22px",
                          letterSpacing: "-0.3%",
                          color: "#aaa",
                        }}
                      >
                        {item.title}
                      </PretendardText>
                      <PretendardText
                        className="truncate"
                        style={{
                          width: "100%",
                          fontWeight: 500,
                          fontSize: 13,
                          lineHeight: "18.75px",
                          color: "rgba(181, 181, 181, 0.5)",
                        }}
                      >
                        {moment(item.updatedAt).format("YYYY-MM-DD HH:mm")}
                      </PretendardText>
                    </div>
                    <RedBtn
                      onClick={() => {
                        setDeleteStorageItemId(item.id);
                        setDeleteStorageItemModalOpen(true);
                      }}
                    >
                      삭제
                    </RedBtn>
                  </div>
                );
              })}
            </div>
          </Popup>
        </PopupOverLay>
      )}

      {/* 목차 삭제 모달창 */}
      {deleteModalOpen && (
        <Modal
          type="negative"
          title="삭제하시겠습니까?"
          text={
            <>
              삭제된 데이터는 복구가 불가합니다.
              <br />
              그래도 삭제하시겠습니까?
            </>
          }
          setModalOpen={setDeleteModalOpen}
          onClick={deleteHandler}
        />
      )}

      {/* 목차 상태 변경 모달창 */}
      {chapterStatusModalOpen && (
        <Modal
          title={`${chapterStatusModalTitle}하시겠습니까?`}
          setModalOpen={setChapterStatusModalOpen}
          onClick={activationFunc}
        />
      )}

      {/* 대제목 삭제하기 모달창 */}
      {chapterTitleDeleteModalOpen && (
        <Modal
          type="negative"
          title="삭제하시겠습니까?"
          text={
            <>
              삭제된 데이터는 복구가 불가합니다.
              <br />
              그래도 삭제하시겠습니까?
            </>
          }
          setModalOpen={setChapterTitleDeleteModalOpen}
          onClick={chapterTitleDeleteHandler}
        />
      )}

      {/* 임시저장 삭제하기 모달 */}
      {deleteStorageItemModalOpen && (
        <Modal
          type="negative"
          title="삭제하시겠습니까?"
          text={
            <>
              삭제된 데이터는 복구가 불가합니다.
              <br />
              그래도 삭제하시겠습니까?
            </>
          }
          setModalOpen={setDeleteStorageItemModalOpen}
          onClick={handleDeleteStorageItem}
        />
      )}
    </>
  );
};

export default ShoppingProductCreateChapter;
